import script from "./EVPlaceholder.vue?vue&type=script&lang=ts&setup=true"
export * from "./EVPlaceholder.vue?vue&type=script&lang=ts&setup=true"

import "./EVPlaceholder.vue?vue&type=style&index=0&id=78016a45&lang=scss&scoped=true"

import exportComponent from "/builds/rentalcar-app/admin-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78016a45"]])

export default __exports__